<template>
  <div class="hero-slider">
    <swiper :options="swiperOption">
      <swiper-slide class="featured-dorms__col col-xl-3 col-lg-3 col-md-4"
        v-for="item in items"
        :key="item.id">
        <div class="hero-slider__item" v-on:click="openDorm(item.id, item.slug)">
          <img :src="item.logo ? item.logo : require('@/assets/img/yurt-logo-default.jpg')" alt="" class="hero-slider__logo">
          <div class="hero-slider__title" v-if="!item.branch_count > 0 && !item.center_slug">{{ item.name }}</div>
          <div class="hero-slider__title" v-if="item.branch_count > 0 && item.center_slug">{{ item.center_name }}</div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'HeroSlider',
  data () {
    return {
      center_name: null,
      dorm: null,
      items: [],
      swiperOption: {
        centeredSlides: false,
        slidesPerGroup: 4,
        spaceBetween: 0,
        slidesPerView: 4,
        breakpoints: {
          768: {
            spaceBetween: 10,
            slidesPerGroup: 3,
            slidesPerView: 3,
            centeredSlides: false
          },
          640: {
            slidesPerView: 1,
            centeredSlides: true,
            slidesPerGroup: 1,
            spaceBetween: 10
          },
          320: {
            slidesPerView: 'auto',
            centeredSlides: true,
            slidesPerGroup: 1

          }
        },
        simulateTouch: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  methods: {
    openDorm (id, slug) {
      let dorm = this.items.find(function (dorm) { return dorm.id === id })
      if (dorm.branch_count > 0 && dorm.center_slug) {
        // const url = self.$attrs.redirect ? `/site/dorm/detail/old/${dormID}` : `/site/dorm/detail/${this.$route.params.id}`
        window.localStorage.setItem('branchnumber', dorm.branch_count)
        window.localStorage.setItem('branchedDormTitle', dorm.center_name)
        window.localStorage.setItem('branchDescription', dorm.description)
        window.localStorage.setItem('branchKeywords', dorm.keywords)
        window.localStorage.setItem('branchedDormId', dorm.id)
        window.localStorage.setItem('dormLogo', dorm.logo)
        window.localStorage.setItem('dormWeb', dorm.web)
        window.localStorage.setItem('slug', dorm.center_slug)
        window.localStorage.setItem('city_id', dorm.city_id)
        if (dorm.center_description) {
          window.localStorage.setItem('center_description', dorm.description)
          window.localStorage.setItem('center_keywords', dorm.keywords)
        }

        // let dorm = this.string_to_slug(this.dorm.slug)
        let route = { name: 'BranchMain', params: { dorm: dorm.center_slug, id: dorm.id } }
        this.$router.push(route)
      } else {
        window.localStorage.setItem('dormid', id)
        // let url = window.location.origin +
        let url = 'http://www.yurtlarburada.com/' + slug + '-y-' + id
        window.localStorage.setItem('url', url)
        window.localStorage.setItem('slug', slug + '-y-' + id)
        // window.localStorage.setItem('description', this.dorm.description)
        // window.localStorage.setItem('name', this.dorm.name)
        if (this.$helpers.mobileCheck()) {
          window.open(window.location.origin + '/' + slug + '-y-' + id, '_self')
        } else {
          window.open(window.location.origin + '/' + slug + '-y-' + id, '_blank')
        }
      }
    },
    getDorms () {
      let self = this
      axios.get('/site/home/slider-promote-dorms')
        .then(response => {
          self.items = response.data
          self.dorm = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  created () {
    this.getDorms()
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/components/hero-slider";
</style>
